import { type TextInputField } from "~/api/tills/types";

type MatchesTextInputScopeParams = {
  scope: TextInputField["scope"];
  schoolId: string | null | undefined;
  groupName: string | null | undefined;
};

/**
 * Whether a text input scoped to `scope` applies to a shopper from `groupName`
 * at `schoolId`. An input with no scope, or none for this school, applies to
 * everyone; a school entry without selectors applies to the whole school.
 */
export function matchesTextInputScope({
  scope,
  schoolId,
  groupName
}: MatchesTextInputScopeParams): boolean {
  if (!scope || !schoolId) return true;

  const schoolScope = scope.schools?.[schoolId];
  if (!schoolScope) return true;

  const { selectorStrings, selectors } = schoolScope;

  if (!selectorStrings?.length && !selectors?.length) return true;
  if (!groupName) return false;

  if (selectorStrings?.length) return selectorStrings.includes(groupName);

  // Group names are the selector option names joined in layer order, the
  // same flat form the school endpoint exposes as `groupNames`.
  return (selectors ?? []).some(
    (selector) => Object.values(selector).join("") === groupName
  );
}
